/** SharePoint list titles — must match provisioning/Provision-SSPAuditPlus.ps1. */
export const LISTS = {
  stores: 'Stores',
  districts: 'Districts',
  userRoles: 'UserRoles',
  auditTemplates: 'AuditTemplates',
  audits: 'Audits',
  auditResponses: 'AuditResponses',
  auditNotes: 'AuditNotes',
  tasks: 'Tasks',
  taskComments: 'TaskComments',
  auditRevisions: 'AuditRevisions',
  notificationConfig: 'NotificationConfig',
  notificationLog: 'NotificationLog',
  appSettings: 'AppSettings',
  emailAllowlist: 'EmailAllowlist',
  flowRuns: 'FlowRuns',
  reportSubscriptions: 'ReportSubscriptions',
  apiActivity: 'ApiActivity',
  /** Monthly district summaries (server-owned; src/audit/districtSummary.ts). */
  districtSummaries: 'DistrictSummaries',
  storeAuditStatus: 'StoreAuditStatus',
  storeTemplateOverrides: 'StoreTemplateOverrides',
  /** Per-store monthly KPI budgets (B8; src/audit/budgets.ts). */
  storeBudgets: 'StoreBudgets',
  /** Notify on completion (2026-10-27; src/data/completionSubscriptions.ts). */
  completionSubscriptions: 'CompletionSubscriptions',
  /** A person's own settings — their time zone (2026-10-28; src/data/userSettings.ts). */
  userSettings: 'UserSettings',
  /** Store owners (2026-10-28; src/data/owners.ts) — Stores.OwnerId points here. */
  owners: 'Owners',
  attachmentsLibrary: 'AuditAttachments',
} as const;

/** How long small, often-read lists are reused within a tab (graph/readCache.ts, G10). */
export const READ_CACHE_MS = 60_000;
